// Loading.tsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import type { SizedAlertProps } from './Alert';
import { Alert } from './Alert';

export const LoadingPromptAlert = ({ children, ...rest }: SizedAlertProps) => {
  return (
    <Alert {...rest}>
      <LoadingPrompt>{children}</LoadingPrompt>
    </Alert>
  );
};

type LoadingPromptProps = {
  children?: React.ReactNode;
};

export const LoadingPrompt = ({ children }: LoadingPromptProps) => {
  const iconClassName = children ? 'me-1' : undefined;

  return (
    <>
      <FontAwesomeIcon icon={faSpinner} spin className={iconClassName} />
      {children}
    </>
  );
};
